import {
  arrayOf,
  bool as boolType,
  customType,
  params,
  string as stringType,
  shape as shapeType,
  number as numberType,
} from '@thd-nucleus/data-sources';

export const GET_RENTAL_FDAV1_QUERY = {
  getRentalFdaV1: params({
    categoryCode: stringType(),
    subCategoryCode: stringType(),
    storeList: arrayOf(stringType()),
    reservationDate: stringType(),
    endDate: stringType()
  }).arrayOf(shapeType({
    availableHours: arrayOf(shapeType({
      start: stringType(),
      end: stringType()
    })),
    availableQty: numberType(),
    bufferQty: numberType(),
    canReserve: boolType(),
    endDate: stringType(),
    locationNbr: stringType(),
    rentalHours: shapeType({
      endDateHours: shapeType({
        close: stringType(),
        open: stringType(),
      }),
      startDateHours: shapeType({
        close: stringType(),
        open: stringType(),
      }),
      timeZoneId: stringType(),
      weeklyHours: shapeType({
        monday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        tuesday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        wednesday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        thursday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        friday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        saturday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        sunday: shapeType({
          close: stringType(),
          open: stringType()
        })
      })
    }),
    startDate: stringType(),
    unAvailableHours: arrayOf(
      shapeType({
        start: stringType(),
        end: stringType()
      })
    ),
  }))
};

const FDAv4Tools = customType('FDAv4Tools').shape({
  categoryCode: stringType(),
  subCategoryCode: stringType(),
  pickupTime: stringType(),
  returnTime: stringType(),
  count: numberType()
});

export const GET_RENTAL_FDAV4_QUERY = {
  getRentalFdaV4: params({
    storeList: arrayOf(stringType()),
    tools: arrayOf(FDAv4Tools),
    reservationId: stringType(),
    appFlow: stringType(),
  }).mutation().arrayOf(shapeType({
    availableHours: arrayOf(shapeType({
      start: stringType(),
      end: stringType()
    })),
    availableQty: numberType(),
    bufferQty: numberType(),
    canReserve: boolType(),
    endDate: stringType(),
    locationNbr: stringType(),
    rentalHours: shapeType({
      endDateHours: shapeType({
        close: stringType(),
        open: stringType(),
      }),
      startDateHours: shapeType({
        close: stringType(),
        open: stringType(),
      }),
      timeZoneId: stringType(),
      weeklyHours: shapeType({
        monday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        tuesday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        wednesday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        thursday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        friday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        saturday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        sunday: shapeType({
          close: stringType(),
          open: stringType()
        })
      })
    }),
    startDate: stringType(),
    unAvailableHours: arrayOf(
      shapeType({
        start: stringType(),
        end: stringType()
      })
    ),
  }))
};

export const GET_RENTAL_FDAV1_MODIFYING_QUERY = {
  getRentalFdaV1Modifying: params({
    category: stringType(),
    subCategory: stringType(),
    startTime: stringType(),
    endTime: stringType(),
    locationNbr: stringType(),
    reservationId: stringType()
  }).mutation().arrayOf(shapeType({
    availableHours: arrayOf(shapeType({
      start: stringType(),
      end: stringType()
    })),
    availableQty: numberType(),
    bufferQty: numberType(),
    canReserve: boolType(),
    endDate: stringType(),
    locationNbr: stringType(),
    rentalHours: shapeType({
      endDateHours: shapeType({
        close: stringType(),
        open: stringType()
      }),
      startDateHours: shapeType({
        close: stringType(),
        open: stringType()
      }),
      timeZoneId: stringType(),
      weeklyHours: shapeType({
        monday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        tuesday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        wednesday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        thursday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        friday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        saturday: shapeType({
          close: stringType(),
          open: stringType()
        }),
        sunday: shapeType({
          close: stringType(),
          open: stringType()
        })
      })
    }),
    startDate: stringType(),
    unAvailableHours: arrayOf(
      shapeType({
        start: stringType(),
        end: stringType()
      })
    )
  }))
};

export const SUBMIT_RENTAL_RESERVATION_MODIFICATION_QUERY = {
  submitRentalReservationModification: params({
    uuid: stringType(),
    pickup_time: stringType(),
    return_time: stringType(),
    user_id: stringType(),
    reservationId: numberType()
  }).mutation().string()
};

export const GET_RENTAL_RESERVATION_QUERY = {
  getRentalReservation: params({
    reservationId: numberType()
  }).shape({
    email: stringType(),
    id: stringType(),
    order: shapeType({
      id: stringType(),
      created_at: stringType(),
      fraud_status: stringType(),
      opt_in: stringType(),
      order_number: stringType(),
      payment_attempted: boolType(),
      rental_agreement_number: stringType(),
      reservation_id: stringType(),
      sms_phone_number: stringType(),
      updated_at: stringType()
    }),
    status: stringType(),
    tools: arrayOf(shapeType({
      description: stringType(),
      id: stringType(),
      status: stringType(),
      category_code: stringType(),
      created_at: stringType(),
      deposit_amount: stringType(),
      inventory_id: stringType(),
      reservation_id: stringType(),
      subcategory_code: stringType(),
      unit_reference_number: stringType(),
      updated_at: stringType()
    })),
    canceled_by: stringType(),
    cancellation_reason_code: stringType(),
    contract_terms: boolType(),
    created_at: stringType(),
    customer_modification_disabled_status: shapeType({
      code: stringType(),
      message: stringType()
    }),
    damage_protection: boolType(),
    expiration_time: stringType(),
    first_name: stringType(),
    last_name: stringType(),
    phone_number: stringType(),
    pickup_time: stringType(),
    reservation_uuid: stringType(),
    return_time: stringType(),
    start_time: stringType(),
    store_number: stringType(),
    updated_at: stringType(),
    user_id: stringType()
  })
};

export const RENTAL_RESERVATION_CANCELACTION_QUERY = {
  submitRentalReservationCancellation: params({
    reservationId: stringType(),
    cancelCode: stringType(),
    uuid: stringType()
  }).mutation().shape({
    type: stringType()
  })
};

const Tools = customType('RentalInformation_getRentalMarketCheck_DeliveryTool').shape({
  categoryCode: stringType(),
  subcategoryCode: stringType()
});

export const GET_RENTAL_MARKET_CHECK_QUERY = {
  getRentalMarketCheck: params({
    zipcode: stringType().isRequired(),
    tools: arrayOf(Tools)
  }).mutation().shape({
    allocationStore: stringType(),
    deliveryEnabled: boolType(),
    deliveryZipcode: stringType(),
    validZipcode: boolType(),
    marketName: stringType(),
    deliverySlots: arrayOf(shapeType({
      date: stringType(),
      slots: arrayOf(stringType())
    })),
    marketCode: stringType(),
    tools: arrayOf(shapeType({
      categoryCode: stringType(),
      subcategoryCode: stringType(),
      description: stringType(),
      quantity: stringType()
    }))
  })
};

export const GET_RENTAL_CONSUMABLES_QUERY = {
  getRentalConsumables: params({
    categoryCode: stringType().isRequired(),
    subCategoryCode: stringType().isRequired(),
  }).shape({
    consumables: arrayOf(shapeType({
      categoryCode: stringType(),
      subCategoryCode: stringType(),
      description: stringType(),
      consumable: stringType(),
      price: stringType(),
    }))
  })
};
